import { DynamicViewData } from "src/dynamic-view-renderer/DynamicViewRenderer.typings.ts";
import { ViewConfiguration } from "src/dynamic-view-renderer/DynamicViewSchemaProvider/DynamicViewSchemaProvider.types.ts";
import TabbedView, { TabbedViewProps } from "src/dynamic-view-renderer/Views/TabbedView.tsx";

export type DynamicViewBaseProps = {
  viewConfiguration: ViewConfiguration;
  data: DynamicViewData;
};

export type DynamicViewRendererProps = TabbedViewProps; //other types of views can be added here

export const DynamicViewRenderer = (props: DynamicViewRendererProps) => {
  switch (props.viewConfiguration.type) {
    case "tabbedView":
      return <TabbedView {...props} />;
    default:
      return <div>Unknown view type</div>;
  }
};
